import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import Overview from '@/views/Overview.vue'
import Stops from '@/views/Stops.vue'
import MapView from '@/views/MapView.vue'
import Circulations from '@/views/Circulations.vue'
import NoDistrict from '../views/NoDistrict.vue'
import Schema from '../views/Schema.vue'
import Workday from '../views/Workday.vue'
import Crew from '../views/Crew.vue'
import TrainReversals from '../views/TrainReversals.vue'

Vue.use(VueRouter)

const APP_TITLE = 'Commando Mobile'

const routes = [
  {
    path: '/',
    alias: '/overview',
    name: 'Overview',
    component: Overview,
    meta: {
      title: 'Översikt'
    }
  },
  {
    path: '/stops',
    name: 'Stops',
    component: Stops,
    meta: {
      title: 'Hållplats'
    }
  },
  {
    path: '/circulations',
    name: 'Circulations',
    component: Circulations,
    meta: {
      title: 'Omlopp'
    }
  },
  {
    path: '/train-reversals',
    name: 'TrainReversals',
    component: TrainReversals,
    meta: {
      title: 'Tågvändningar'
    }
  },
  {
    path: '/map-view/:trip_uuid',
    name: 'MapView',
    component: MapView,
    meta: {
      title: 'Kartvy'
    }
  },
  {
    path: '/no-district',
    name: 'NoDistrict',
    component: NoDistrict,
    meta: {
      title: 'Inget gilltigt distrikt'
    }
  },
  {
    path: '/schema',
    name: 'Schema',
    component: Schema,
    meta: {
      title: 'Schema'
    }
  },
  {
    path: '/workday/:date/:employeenumber?',
    name: 'Workday',
    component: Workday,
    meta: {
      title: 'Arbetsdag'
    }
  },
  {
    path: '/crew/:date?/:trip?',
    name: 'Crew',
    component: Crew,
    meta: {
      title: 'Besättning'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.commit('app/SET_DRAWER', false)
  window.scrollTo(0, 0)
  document.title = `${APP_TITLE} - ${to.meta.title}`

  next()
})

export default router
